(function (global) {
    define('LNRS/Components/IndustrySection',[
        "jquery","vue", "underscore", "Utility/ErrorHandler"
    ], function ($, Vue, _, errorHandler) {

        var currentPageTemplate = $("body").attr("data-page-template");
        var pageId = $("body").attr("data-page-id");
        var component = {
            mounted: function () {
                $(".second-step", this.$el). removeAttr("style");
                $(this.$el).attr("data-ux-state", "loaded").removeAttr("data-ux-args");
                //$(".first-step ul.nav li", this.$el).matchHeight();
            },
            watch: {
                loading: function() {
                    if (this.loading === false) {
                       // setTimeout(function () { $(".second-step ul.level-1 li", this.$el).matchHeight(); }, 200);
                    }
                }
            },
            methods: {
                getSubSection: function (e) {
                    localStorage.setItem("industrySection", "1");
                    this.currentStep = 2;
                    this.currentIndustryId = e.currentTarget.dataset.industryid;
                    /*this.tagretlanguage = e.currentTarget.dataset.tagretlang;
                    this.currentIndustryName = e.currentTarget.dataset.industryname;
                    this.currentIndustryLink = e.currentTarget.dataset.industrylink;
                    this.currentIndustryLinkText = this.currentIndustryLinkTextMask.replace("$currentIndustryName", this.currentIndustryName);
                    this.currentGeneralDescription = _.find(this.generalDescriptions, function (item) {
                        return item[0] === this.currentIndustryId;
                    }.bind(this))[1];
                    this.loading = true;
                    $.ajax({
                        url: "/GetSubSections",
                        type: "GET",
                        data: { industryId: this.currentIndustryId, language: this.tagretlanguage, count: this.maxRecordsCount, indexName: this.algoliaIndexName, global: window.location.href.toLowerCase().includes('/global/') },
                        traditional: true,
                        dataType: "json"
                    })
                    .done(function (response) {
                        var groups = _.groupBy(response, function (row) { return row.GroupName; });
                        var all = _.map(groups, function (group) {
                            group["GroupName"] = group[0].GroupTranslatedName || "_empty";
                            group["GroupSortOrder"] = group[0].GroupSortOrder;
                            return group;
                        });                            
                        this.subIndustryGroups = _.sortBy(all, function (group) {
                            return group.GroupSortOrder;
                        });                       
                    }.bind(this))
                    .fail(function() {
                        errorHandler.logError("IndustrySection.js: Something was wrong during executing of 'NavigationController.GetSubSections' method for industryId: " + this.currentIndustryId + ", language: " + this.tagretlanguage + ".");
                    }.bind(this))
                    .always(function() {
                        this.loading = false;
                        localStorage.removeItem("industrySection");
                    }.bind(this));*/
                },
                linkClick: function (e) {
                    if (e.currentTarget.parentElement.classList.contains("active") && window.innerWidth >= 992) {
                        localStorage.setItem("industrySection", "1");
                        setTimeout(function() {
                            localStorage.removeItem("industrySection");
                        }, 300);
                        return;
                    } else {
                        this.getSubSection(e);
                    }
                },
                backStep2Click: function() {
                    this.currentStep = 1;
                },
                backStep1Click: function () {
                    this.currentIndustryId = null;
                    this.$el.classList.remove("open");
                }
            }
        };

        window.onload = function () {
            if (currentPageTemplate === "b106503b-de36-4c69-95d2-8ecf22e7fb66") {
                var industryLnk = document.querySelector('[data-industryid="' + pageId + '"]');
                if (industryLnk) {
                    industryLnk.click();
                }
            }
        }

        return function init(args) {
            component.el = args.scope;
            component.data = {
                currentStep: 1,
                subIndustryGroups: null,
                currentIndustryId: null,
                tagretlanguage: null,
                currentIndustryName: null,
                currentIndustryLink: null,
                currentIndustryLinkText: null,
                currentIndustryLinkTextMask: args.IndustryLinkTextMask,
                algoliaIndexName: args.IndexName,
                loading: false,
                generalDescriptions: args.GeneralDescriptions,
                maxRecordsCount: 500,
                currentGeneralDescription: null
            };
            return args.IsPageEditorEditing === true ? null : new Vue(component);
        };       
    });
})(this);
